var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('checkpoint-overview',{attrs:{"checkpoint":_vm.finding.checkpoint,"resolved":Boolean(_vm.finding.resolved_at)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }